import * as React from "react";

import { Radio } from "../formik";
import { ARMIES, Color } from "./GameState";
import ArmyLabel from "./ArmyLabel";

import styles from "./ArmyInput.module.css";

type Props = {
  value: string;
  name: string;
  color?: Color;
  // We strip out onBlur for this to prevent the field from becoming invalid
  // when just tabbing through options.
  onBlur: any;
};

const ArmyInput = ({
  value,
  color,
  onBlur,
  ...rest
}: Props): React.ReactNode => (
  <div>
    {ARMIES.map((army) => (
      <div key={army}>
        <Radio
          style={{ padding: "2px 0" }}
          label={
            <ArmyLabel
              className={styles.ArmyLabel}
              army={army}
              labelColor={value === army ? "yellow" : "grey"}
              color={color || "white"}
            />
          }
          value={army}
          {...rest}
        />
      </div>
    ))}
  </div>
);

export default ArmyInput;
